// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"9ec92dfd","246":"1a205f68","405":"0343e5d1","526":"7fd8d7ae","809":"5aa8a78e"}[chunkId] + ".css";
};